import React from 'react'
import { Card, CardBody } from "reactstrap";

function InfoCardsV2({ title, mainValue, subtitle, icon, iconBgColor, iconColor, subtitleColor = "#9CA3AF" }) {
    return (
        <Card style={{
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            border: "none",
            borderRadius: "12px",
            minWidth: "260px",

        }}>
            <CardBody style={{
                borderRadius: "12px"
            }} className='dash_card_body'>
                <div className="d-flex justify-content-between align-items-center">
                    <h2 style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#374151",

                    }}>{title}</h2>
                    <div style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: iconBgColor,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600
                    }}>
                        {React.cloneElement(icon, {
                            size: 24,
                            style: { color: iconColor, fontWeight: "bold" }
                        })}
                    </div>
                </div>

                <h2 style={{
                    fontSize: "48px",
                    fontWeight: "700",
                    color: "#111827",
                }}>{mainValue}</h2>
                <p style={{
                    fontSize: "14px",
                    color: subtitleColor,
                }}>{subtitle}</p>
            </CardBody>
        </Card>
    )
}

export default InfoCardsV2;